(() => {
  const key = '__fcmPostquirurgicas';
  if (window[key]) { window[key](); return; }
  let frame;
  const init = () => {
    document.querySelectorAll('[data-fcm-pq]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.querySelectorAll('.fcm-pq__faq details').forEach((details) => {
        const sync = () => details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
        sync();
        details.addEventListener('toggle', sync);
      });
      root.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#fcm-pq-"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
    schedule();
  };
  // Keep the existing floating WhatsApp area free; yield to cart, cookies,
  // modal dialogs, keyboards, and other fixed overlays instead of moving them.
  const checkOverlays = () => {
    frame = undefined;
    const roots = document.querySelectorAll('[data-fcm-pq]');
    if (!roots.length || !matchMedia('(max-width: 749px)').matches) return;
    const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.75;
    const modalOpen = !!document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])');
    const candidates = document.querySelectorAll('[class*="cookie" i], [id*="cookie" i], [class*="consent" i], [id*="consent" i], [class*="whatsapp" i], [id*="whatsapp" i], [class*="chat-widget" i], [class*="drawer" i], [role="dialog"], [style*="fixed"]');
    roots.forEach((root) => {
      const sticky = root.querySelector('[data-fcm-pq-sticky]');
      if (!sticky) return;
      // Stable projected rect also works while the bar is hidden.
      const area = { left: 12, right: innerWidth - 88, top: innerHeight - 105, bottom: innerHeight };
      let blocked = keyboard || modalOpen;
      for (const el of candidates) {
        if (blocked) break;
        if (root.contains(el)) continue;
        const style = getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
        const rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height) continue;
        if (rect.left < area.right && rect.right > area.left && rect.top < area.bottom && rect.bottom > area.top) blocked = true;
      }
      const hidden = !!blocked;
      if (sticky.hidden !== hidden) sticky.hidden = hidden;
    });
  };
  const schedule = () => { if (!frame) frame = setTimeout(checkOverlays, 120); };
  window[key] = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', schedule);
  addEventListener('resize', schedule, { passive: true });
  addEventListener('scroll', schedule, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'class', 'style', 'aria-hidden', 'aria-modal'] });
})();
